import React, { useState } from 'react';
import { supabase } from './supabaseClient';

export default function RegisterWithPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    const { error } = await supabase.from('mailing_list').insert([{ email }]);

    if (error) {
      alert('❌ Error saving email');
    } else {
      setSubmitted(true);
    }
  };

  return (
    <div style={{ padding: '4rem', textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>✨ Become a Nubbi Creator</h1>
      <h2 style={{ fontSize: '1.4rem', color: '#888', marginBottom: '2rem' }}>COMING SOON!</h2>

      {!submitted ? (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email to join our mailing list"
            required
            style={{
              padding: '0.8rem',
              borderRadius: '10px',
              border: '1px solid #ccc',
              width: '100%',
              maxWidth: '400px',
              marginBottom: '1rem'
            }}
          />
          <br />
          <button type="submit" style={{
            backgroundColor: '#FFD700',
            color: 'black',
            fontWeight: 'bold',
            padding: '0.7rem 1.5rem',
            borderRadius: '12px',
            border: 'none',
            cursor: 'pointer'
          }}>
            ✅ Join Mailing List
          </button>
        </form>
      ) : (
        <p style={{ color: '#28a745', marginTop: '2rem' }}>🎉 You're on the list! We'll let you know when it’s ready.</p>
      )}
    </div>
  );
}
